/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetConfigurationStatus200,
  GetSchedulerStatus200,
  ReminderConfigDTO,
  ToggleConfigurationStatusParams,
  TriggerReminderProcessingParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getConfigurationById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ReminderConfigDTO>(
      {url: `/api/v1/reminder-configurations/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetConfigurationByIdQueryKey = (id?: string,) => {
    return [`/api/v1/reminder-configurations/${id}`] as const;
    }

    
export const getGetConfigurationByIdQueryOptions = <TData = Awaited<ReturnType<typeof getConfigurationById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigurationByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigurationById>>> = ({ signal }) => getConfigurationById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigurationById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConfigurationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigurationById>>>
export type GetConfigurationByIdQueryError = unknown


export function useGetConfigurationById<TData = Awaited<ReturnType<typeof getConfigurationById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigurationById>>,
          TError,
          Awaited<ReturnType<typeof getConfigurationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConfigurationById<TData = Awaited<ReturnType<typeof getConfigurationById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigurationById>>,
          TError,
          Awaited<ReturnType<typeof getConfigurationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConfigurationById<TData = Awaited<ReturnType<typeof getConfigurationById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetConfigurationById<TData = Awaited<ReturnType<typeof getConfigurationById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConfigurationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateConfiguration = (
    id: string,
    reminderConfigDTO: ReminderConfigDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ReminderConfigDTO>(
      {url: `/api/v1/reminder-configurations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: reminderConfigDTO
    },
      options);
    }
  


export const getUpdateConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfiguration>>, TError,{id: string;data: ReminderConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConfiguration>>, TError,{id: string;data: ReminderConfigDTO}, TContext> => {

const mutationKey = ['updateConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConfiguration>>, {id: string;data: ReminderConfigDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateConfiguration(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateConfiguration>>>
    export type UpdateConfigurationMutationBody = ReminderConfigDTO
    export type UpdateConfigurationMutationError = unknown

    export const useUpdateConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfiguration>>, TError,{id: string;data: ReminderConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConfiguration>>,
        TError,
        {id: string;data: ReminderConfigDTO},
        TContext
      > => {

      const mutationOptions = getUpdateConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const deleteConfiguration = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/v1/reminder-configurations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConfiguration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConfiguration>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConfiguration>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteConfiguration(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConfiguration>>>
    
    export type DeleteConfigurationMutationError = unknown

    export const useDeleteConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConfiguration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConfiguration>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAllConfigurations = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ReminderConfigDTO[]>(
      {url: `/api/v1/reminder-configurations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllConfigurationsQueryKey = () => {
    return [`/api/v1/reminder-configurations`] as const;
    }

    
export const getGetAllConfigurationsQueryOptions = <TData = Awaited<ReturnType<typeof getAllConfigurations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllConfigurationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllConfigurations>>> = ({ signal }) => getAllConfigurations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllConfigurationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllConfigurations>>>
export type GetAllConfigurationsQueryError = unknown


export function useGetAllConfigurations<TData = Awaited<ReturnType<typeof getAllConfigurations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllConfigurations<TData = Awaited<ReturnType<typeof getAllConfigurations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllConfigurations<TData = Awaited<ReturnType<typeof getAllConfigurations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllConfigurations<TData = Awaited<ReturnType<typeof getAllConfigurations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllConfigurationsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createConfiguration = (
    reminderConfigDTO: ReminderConfigDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ReminderConfigDTO>(
      {url: `/api/v1/reminder-configurations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reminderConfigDTO, signal
    },
      options);
    }
  


export const getCreateConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConfiguration>>, TError,{data: ReminderConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createConfiguration>>, TError,{data: ReminderConfigDTO}, TContext> => {

const mutationKey = ['createConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConfiguration>>, {data: ReminderConfigDTO}> = (props) => {
          const {data} = props ?? {};

          return  createConfiguration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof createConfiguration>>>
    export type CreateConfigurationMutationBody = ReminderConfigDTO
    export type CreateConfigurationMutationError = unknown

    export const useCreateConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConfiguration>>, TError,{data: ReminderConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConfiguration>>,
        TError,
        {data: ReminderConfigDTO},
        TContext
      > => {

      const mutationOptions = getCreateConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const triggerConfiguration = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/v1/reminder-configurations/${id}/trigger`, method: 'POST', signal
    },
      options);
    }
  


export const getTriggerConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerConfiguration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerConfiguration>>, TError,{id: string}, TContext> => {

const mutationKey = ['triggerConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerConfiguration>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  triggerConfiguration(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof triggerConfiguration>>>
    
    export type TriggerConfigurationMutationError = unknown

    export const useTriggerConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerConfiguration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerConfiguration>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTriggerConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const triggerReminderProcessing = (
    params?: TriggerReminderProcessingParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/v1/reminder-configurations/trigger-reminders`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getTriggerReminderProcessingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerReminderProcessing>>, TError,{params?: TriggerReminderProcessingParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerReminderProcessing>>, TError,{params?: TriggerReminderProcessingParams}, TContext> => {

const mutationKey = ['triggerReminderProcessing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerReminderProcessing>>, {params?: TriggerReminderProcessingParams}> = (props) => {
          const {params} = props ?? {};

          return  triggerReminderProcessing(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerReminderProcessingMutationResult = NonNullable<Awaited<ReturnType<typeof triggerReminderProcessing>>>
    
    export type TriggerReminderProcessingMutationError = unknown

    export const useTriggerReminderProcessing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerReminderProcessing>>, TError,{params?: TriggerReminderProcessingParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerReminderProcessing>>,
        TError,
        {params?: TriggerReminderProcessingParams},
        TContext
      > => {

      const mutationOptions = getTriggerReminderProcessingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const triggerDefaultReminderProcessing = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/v1/reminder-configurations/trigger-default-reminders`, method: 'POST', signal
    },
      options);
    }
  


export const getTriggerDefaultReminderProcessingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerDefaultReminderProcessing>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerDefaultReminderProcessing>>, TError,void, TContext> => {

const mutationKey = ['triggerDefaultReminderProcessing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerDefaultReminderProcessing>>, void> = () => {
          

          return  triggerDefaultReminderProcessing(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerDefaultReminderProcessingMutationResult = NonNullable<Awaited<ReturnType<typeof triggerDefaultReminderProcessing>>>
    
    export type TriggerDefaultReminderProcessingMutationError = unknown

    export const useTriggerDefaultReminderProcessing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerDefaultReminderProcessing>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerDefaultReminderProcessing>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getTriggerDefaultReminderProcessingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getConfigurationStatus = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetConfigurationStatus200>(
      {url: `/api/v1/reminder-configurations/${id}/status`, method: 'GET', signal
    },
      options);
    }
  

export const getGetConfigurationStatusQueryKey = (id?: string,) => {
    return [`/api/v1/reminder-configurations/${id}/status`] as const;
    }

    
export const getGetConfigurationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getConfigurationStatus>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigurationStatusQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigurationStatus>>> = ({ signal }) => getConfigurationStatus(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigurationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConfigurationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigurationStatus>>>
export type GetConfigurationStatusQueryError = unknown


export function useGetConfigurationStatus<TData = Awaited<ReturnType<typeof getConfigurationStatus>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigurationStatus>>,
          TError,
          Awaited<ReturnType<typeof getConfigurationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConfigurationStatus<TData = Awaited<ReturnType<typeof getConfigurationStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigurationStatus>>,
          TError,
          Awaited<ReturnType<typeof getConfigurationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConfigurationStatus<TData = Awaited<ReturnType<typeof getConfigurationStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetConfigurationStatus<TData = Awaited<ReturnType<typeof getConfigurationStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigurationStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConfigurationStatusQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const toggleConfigurationStatus = (
    id: string,
    params: ToggleConfigurationStatusParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ReminderConfigDTO>(
      {url: `/api/v1/reminder-configurations/${id}/status`, method: 'PATCH',
        params
    },
      options);
    }
  


export const getToggleConfigurationStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleConfigurationStatus>>, TError,{id: string;params: ToggleConfigurationStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleConfigurationStatus>>, TError,{id: string;params: ToggleConfigurationStatusParams}, TContext> => {

const mutationKey = ['toggleConfigurationStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleConfigurationStatus>>, {id: string;params: ToggleConfigurationStatusParams}> = (props) => {
          const {id,params} = props ?? {};

          return  toggleConfigurationStatus(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleConfigurationStatusMutationResult = NonNullable<Awaited<ReturnType<typeof toggleConfigurationStatus>>>
    
    export type ToggleConfigurationStatusMutationError = unknown

    export const useToggleConfigurationStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleConfigurationStatus>>, TError,{id: string;params: ToggleConfigurationStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleConfigurationStatus>>,
        TError,
        {id: string;params: ToggleConfigurationStatusParams},
        TContext
      > => {

      const mutationOptions = getToggleConfigurationStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getSchedulerStatus = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSchedulerStatus200>(
      {url: `/api/v1/reminder-configurations/scheduler/status`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSchedulerStatusQueryKey = () => {
    return [`/api/v1/reminder-configurations/scheduler/status`] as const;
    }

    
export const getGetSchedulerStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSchedulerStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedulerStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchedulerStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedulerStatus>>> = ({ signal }) => getSchedulerStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchedulerStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSchedulerStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedulerStatus>>>
export type GetSchedulerStatusQueryError = unknown


export function useGetSchedulerStatus<TData = Awaited<ReturnType<typeof getSchedulerStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedulerStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedulerStatus>>,
          TError,
          Awaited<ReturnType<typeof getSchedulerStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSchedulerStatus<TData = Awaited<ReturnType<typeof getSchedulerStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedulerStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedulerStatus>>,
          TError,
          Awaited<ReturnType<typeof getSchedulerStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSchedulerStatus<TData = Awaited<ReturnType<typeof getSchedulerStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedulerStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSchedulerStatus<TData = Awaited<ReturnType<typeof getSchedulerStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedulerStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSchedulerStatusQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getActiveConfigurationsForInstitution = (
    institutionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ReminderConfigDTO[]>(
      {url: `/api/v1/reminder-configurations/institution/${institutionId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetActiveConfigurationsForInstitutionQueryKey = (institutionId?: string,) => {
    return [`/api/v1/reminder-configurations/institution/${institutionId}`] as const;
    }

    
export const getGetActiveConfigurationsForInstitutionQueryOptions = <TData = Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError = unknown>(institutionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveConfigurationsForInstitutionQueryKey(institutionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>> = ({ signal }) => getActiveConfigurationsForInstitution(institutionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(institutionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActiveConfigurationsForInstitutionQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>>
export type GetActiveConfigurationsForInstitutionQueryError = unknown


export function useGetActiveConfigurationsForInstitution<TData = Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError = unknown>(
 institutionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>,
          TError,
          Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveConfigurationsForInstitution<TData = Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>,
          TError,
          Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveConfigurationsForInstitution<TData = Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActiveConfigurationsForInstitution<TData = Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfigurationsForInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActiveConfigurationsForInstitutionQueryOptions(institutionId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



